import { Component, Input } from '@angular/core';
import { TrackToolStep } from '@analytics/models';
import { ScTextFormInput } from '@innogy/sitecore-forms/models';
import { FormState } from 'ngrx-forms';
import { TextComponent } from '@innogy/common-ui/forms';

@Component({
  selector: 'wl-sc-text[control][fields][trackStep]',
  templateUrl: './sc-text.component.html',
  standalone: true,
  imports: [TextComponent],
})
export class ScTextComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() control!: FormState<string>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fields!: ScTextFormInput;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabel = false;
}
